module.exports = __webpack_public_path__ + "static/media/next.f876f461.svg";